import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['search', 'row', 'checkbox', 'groupCheckbox', 'childCheckbox', 'counter', 'noResults']

  connect() {
    this.groupCheckboxTargets.forEach((checkbox) => this.paintGroup(checkbox.dataset.group));
    this.refreshCounter();
  }

  filter() {
    const term = this.searchTarget.value.trim().toLowerCase();
    let visible = 0;

    for (const row of this.rowTargets) {
      const matches = term === '' || (row.dataset.search || '').includes(term);
      row.classList.toggle('hidden', !matches);
      if (matches) visible += 1;
    }

    this.noResultsTarget.classList.toggle('hidden', visible > 0);
  }

  // Marcar o veículo marca os equipamentos acoplados: a regra vale para o
  // conjunto, não só para o chassi.
  toggleGroup(event) {
    const { group } = event.currentTarget.dataset;
    const checked = event.currentTarget.checked;

    for (const child of this.childrenOf(group)) {
      if (this.isHidden(child)) continue;
      child.checked = checked;
    }

    event.currentTarget.indeterminate = false;
    this.refreshCounter();
  }

  // Desmarcar um equipamento não desmarca o veículo — só tira o "todos".
  syncGroup(event) {
    this.paintGroup(event.currentTarget.dataset.group);
    this.refreshCounter();
  }

  selectAllVisible() {
    for (const checkbox of this.checkboxTargets) {
      if (!this.isHidden(checkbox)) checkbox.checked = true;
    }

    this.groupCheckboxTargets.forEach((checkbox) => this.paintGroup(checkbox.dataset.group));
    this.refreshCounter();
  }

  clear() {
    for (const checkbox of this.checkboxTargets) {
      if (this.isHidden(checkbox)) continue;
      checkbox.checked = false;
      checkbox.indeterminate = false;
    }

    this.refreshCounter();
  }

  refreshCounter() {
    if (!this.hasCounterTarget) return;

    const count = this.checkboxTargets.filter((checkbox) => checkbox.checked).length;
    const { template, empty } = this.counterTarget.dataset;

    this.counterTarget.textContent = count === 0 ? empty : template.replace('%{count}', count);
  }

  paintGroup(group) {
    const parent = this.groupCheckboxTargets.find((checkbox) => checkbox.dataset.group === group);
    if (!parent) return;

    const children = this.childrenOf(group);
    if (children.length === 0) return;

    const checkedChildren = children.filter((child) => child.checked).length;
    parent.indeterminate = parent.checked && checkedChildren > 0 && checkedChildren < children.length;
  }

  childrenOf(group) {
    return this.childCheckboxTargets.filter((checkbox) => checkbox.dataset.group === group);
  }

  isHidden(checkbox) {
    return checkbox.closest('tr').classList.contains('hidden');
  }
}
